import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ClinicalIndustry from "@/pages/ClinicalIndustry";

export const Route = createFileRoute("/es/servicios/clinical-solutions/estudios-de-rendimiento-clinico-de-ivd")({
  head: () => buildRouteHead("/es/servicios/clinical-solutions/estudios-de-rendimiento-clinico-de-ivd"),
  component: ClinicalIndustry,
});

